const PlusIcon = ({ className }) => (
  <div className={className}>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden>
      <path
        d="M8 3.33301V12.6663M3.33333 8H12.6667"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  </div>
);

export default PlusIcon;
